import styled from "styled-components";
import { colors } from "../../../../utils";

export const AuthorInfo = styled.div`
  width: 22vw;
  min-width: 320px;
  border-radius: 10px;
  padding: 10px;
  position: absolute;
  top: 3vh;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  z-index: 100000;
`;

export const AuthorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;
export const LeftView = styled.div`
  display: flex;
  align-items: center;
`;

export const ImageView = styled.div`
  display: flex;
  background-color: ${colors.transparentPurple};
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  margin-right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
`;

export const AuthorView = styled.div`
  display: flex;
  background-color: ${colors.background};
  align-items: center;
  padding: 10px;
  border-radius: 5px;
`;

export const OtherAuthors = styled.div`
  margin-top: 10px;
  border-radius: 5px;
  padding: 5px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px;
`;

export const OtherAuthorView = styled.div`
  background-color: ${colors.white};
  border-radius: 5px;
  max-height: 160px;
  overflow-y: scroll;
`;

export const OtherAuthorItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
`;

export const Separator = styled.div`
  width: 90%;
  height: 1px;
  background-color: ${colors.lightBorder};
  margin: auto;
`;

export const ClonedFrom = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: "100%";
`;
